module.exports = __webpack_public_path__ + "img/device-mobile-ua.7e359358.png";